import { useState } from "react";
import SidebarLogin from "./SidebarLogin";

const SidebarButton = ({infoApi, setShowModalSuccess}) => {
 
    const [show, setShow] = useState(false);

    const handleShow = () => setShow(true);

    return (
        <>
            <div className="sticky__btn__sidebar_down d-md-block d-none ">
                <button className="btn__sidebar_down" type="button" onClick={handleShow} ><b>INGRESA A TU<br/>ECOSISTEMA AQUÍ</b>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <i className="fa-solid fa-angle-up flecha__sticky__btn"></i></button>

                <SidebarLogin
                    infoApi={infoApi}
                    show={show}
                    setShow={setShow}
                    setShowModalSuccess={setShowModalSuccess}
                />

            </div>
        </>
    )
}

export default SidebarButton